webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closest = closest;
exports.wrap = wrap;
exports.mYYYY = mYYYY;
exports.commas = commas;
exports.inMegabytes = inMegabytes;
exports.json = json;
exports.price = price;
/**
 * Lib
 * Tools and such
 */

/**
 * Find Closest parent of element matching selector
 * @param {elementNode} el
 * @param {string} selector
 */

function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  var desiredEl = el;
  while (desiredEl) {
    if (matchesSelector.call(desiredEl, selector)) {
      break;
    }
    desiredEl = desiredEl.parentElement;
  }
  return desiredEl || false;
}

/**
 * Wrap element with a div with a class
 * @param {elementNode} node
 * @param {string} className
 */

function wrap(node, className) {
  var wrapperClass = className || null;
  var container = document.createElement('div');
  if (className) {
    container.className = wrapperClass;
  }
  container.innerHTML = node.outerHTML;
  node.parentElement.insertBefore(container, node);
  node.parentElement.removeChild(node);
}

// Vimeo API

var Vimeo = exports.Vimeo = {

  /**
  * Play a Vimeo video
  * @param {elementNode} el
  */
  play: function play(el) {
    if (!el) return false;
    return el.contentWindow.postMessage({ method: 'play' }, el.src);
  },

  /**
  * Pause a Vimeo video
  * @param {elementNode} el
  */
  pause: function pause(el) {
    if (!el) return false;
    return el.contentWindow.postMessage({ method: 'pause' }, el.src);
  }
};

// Vue filters

function mYYYY(val) {
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var date = new Date(val);
  return monthNames[date.getMonth()] + ' ' + date.getFullYear();
}

function commas(val) {
  if (val > 0) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return false;
}

function inMegabytes(val) {
  return (val / Math.pow(1024, 2)).toFixed(1) + ' MB';
}

function json(val) {
  return JSON.stringify(val);
}

function price(val) {
  if (val > 0) {
    var inCents = val / 100;
    var withCommas = inCents.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + withCommas.replace(/\.00/g, '');
  }
  return false;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Navigation
 * JS components for navigation
 */

var Nav = {};

Nav.nav = function () {
  var navEl = document.querySelector('#ms-nav');
  navEl.classList.add('is-initialized');
  var navSwitchEl = document.querySelector('#ms-nav-switch');
  navSwitchEl.addEventListener('click', function (e) {
    document.documentElement.classList.toggle('is-menu-open');
    e.preventDefault();
  });
};

// <select> navigation

Nav.selectNav = function (selector) {
  selector = selector || 'select';
  var selectEl = document.querySelector(selector);
  selectEl.selectedIndex = 0;
  selectEl.addEventListener('change', function (e) {
    if (selectEl.value[0] === 'h' || selectEl.value[0] === '/') location.replace(e.target.value);else if (selectEl.value[0] === '#') location.hash = selectEl.value;
  });
};

exports.default = Nav;

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(22);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(6);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(7),
    getRawTag = __webpack_require__(24),
    objectToString = __webpack_require__(25);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(7);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _designwise = __webpack_require__(54);

var _designwise2 = _interopRequireDefault(_designwise);

var _nav = __webpack_require__(3);

var _nav2 = _interopRequireDefault(_nav);

var _vids = __webpack_require__(59);

var _vids2 = _interopRequireDefault(_vids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_designwise2.default.init(); /**
                              * Design-wise
                              * Legacy JS for Terms section
                              */

_nav2.default.selectNav('#dw_mobile');
_nav2.default.nav();

(0, _vids2.default)(document.querySelector('#term_window'));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _throttle = __webpack_require__(55);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @section Legacy Module
 */

var dw = {}; /**
              * Design-wise
              * Scrolly JS
              */

/**
 * @section Includes
 */

dw.termY = [];
dw.termID = [];

dw.clickHandler = function (e) {
  var termID = e.target.href.split('#')[1];
  dw.goTo(termID);
  e.preventDefault();
};

dw.init = function () {
  // 1. Set up initial values
  dw.termWindow = document.querySelector('#term_window');
  dw.totalHeight = dw.termWindow.scrollHeight;

  // 2. Scroll to linked term, if any
  var terms = document.querySelectorAll('.dw-term');
  if (window.location.hash.length) {
    dw.currentTerm = parseInt(window.location.hash.split('#')[1]);
  } else {
    dw.currentTerm = parseInt(terms[0].dataset.id);
  }

  // 3. Calculate heights
  terms.forEach(function (el, i) {
    var y = dw.termWindow.scrollTop + el.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top;
    dw.termID.push(parseInt(el.dataset.id));
    dw.termY.push(y);
  });
  dw.goTo(dw.currentTerm);

  // 4. Handle link clicks
  var links = document.querySelectorAll('.dw-nav a');
  links.forEach(function (el, i) {
    el.addEventListener('click', dw.clickHandler);
  });

  // 5. Recalculate heights while loading & resizing
  dw.loading();
  window.addEventListener('resize', dw.measure);
  dw.termWindow.addEventListener('scroll', dw.scrollHandler);

  // 6. Set up mobile nav
  window.addEventListener('scroll', dw.mobileScrollHandler);
};

dw.highlight = (0, _throttle2.default)(function () {
  // 1. Get current category
  var term = dw.currentTerm + "";
  var cat = term.substr(0, term.length - 2);
  if (cat === null || undefined) {
    return false;
  }

  // 2. Show current category pane
  var tabs = document.querySelectorAll('.dw-nav--term');
  tabs.forEach(function (el, i) {
    el.classList.add('is-hiding');
  });
  document.querySelector('#cat_' + cat).classList.remove('is-hiding');

  // 3. Highlight current term & category
  var links = document.querySelectorAll('.dw-nav a');
  links.forEach(function (el, i) {
    el.classList.remove('is-viewing');
  });
  history.replaceState(undefined, undefined, '#' + dw.currentTerm);
  document.querySelector('.dw-nav--term a[data-id="' + term + '"]').classList.add('is-viewing');
  document.querySelector('.dw-nav a[data-cat="' + cat + '00"]').classList.add('is-viewing');
}, 16);

dw.loading = function () {
  var instaClass = '.instagram-media';
  var instaRenderedClass = '.instagram-media-rendered';
  var loadClear = setInterval(function () {
    var insta = document.querySelectorAll(instaClass);
    var instaRendered = document.querySelectorAll(instaRenderedClass);

    // This '+ 1' seems wonky, but for some reason, when scrolled to
    // a term on page load, it adds that term twice to the insta list
    // but doesn't add it to the rendered list
    if (insta.length > instaRendered.length + 1) {
      dw.measure();
    } else {
      clearInterval(loadClear);
      dw.isLoaded = true;
      setTimeout(dw.measure, 500);
    }
  }, 16);
};

dw.goTo = function (term) {
  dw.isNavigating = true;
  var magicAdjustment = 2;
  var termEl = document.querySelector('.dw-term[data-id="' + term + '"]');
  // If valid term
  if (termEl) {
    dw.termWindow.scrollTop = dw.termWindow.scrollTop + termEl.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top + magicAdjustment;
    dw.currentTerm = parseInt(term);
    dw.highlight();

    // If valid category
  } else {
    var cat = document.querySelector('.dw-heading[data-cat="' + term + '"]');
    if (cat) {
      dw.termWindow.scrollTop = dw.termWindow.scrollTop + cat.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top + magicAdjustment;
      dw.currentTerm = parseInt(cat.nextElementSibling.dataset.id);
      dw.highlight();
    }
  }
  dw.isNavigating = false;
};

dw.measure = function () {
  if (dw.termWindow.scrollHeight !== dw.totalHeight) {
    var terms = document.querySelectorAll('.dw-term');
    var diff = [];
    // Get new tops of each
    terms.forEach(function (term, i) {
      var y = Math.floor(dw.termWindow.scrollTop + term.getBoundingClientRect().top - dw.termWindow.getBoundingClientRect().top);
      if (dw.termY[i] !== y) {
        dw.termY[i] = y;
        diff.push(parseInt(term.dataset.id));
      }
    });

    // See if user has scrolled past loaded area
    if (dw.currentTerm >= diff.reduce(function (a, b) {
      return a < b ? a : b;
    })) {
      dw.goTo(dw.currentTerm);
    }
    dw.totalHeight = dw.termWindow.scrollHeight;
  }
};

dw.mobileScrollHandler = (0, _throttle2.default)(function () {
  var mobileNav = document.querySelector('.dw-mobile');
  if (mobileNav.getBoundingClientRect().top <= 0) {
    mobileNav.classList.add('is-fixed');
  } else {
    mobileNav.classList.remove('is-fixed');
  }
}, 33);

dw.scrollHandler = (0, _throttle2.default)(function () {
  if (dw.isLoaded) {
    var magicAdjustment = 64;
    var n = 0;
    while (dw.termWindow.scrollTop + magicAdjustment > dw.termY[n]) {
      n++;
    }
    dw.currentTerm = dw.termID[n - 1];
    dw.highlight();
  }
}, 100);

exports.default = dw;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(56),
    isObject = __webpack_require__(5);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5),
    now = __webpack_require__(57),
    toNumber = __webpack_require__(58);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(6);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5),
    isSymbol = __webpack_require__(23);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (scope) {
  scope = scope || document;
  var videos = scope.querySelectorAll('iframe[src*="player.vimeo.com"], iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"], iframe[src*="kickstarter.com"][src*="video.html"], object, embed');
  videos.forEach(function (video) {
    if ((0, _lib.closest)(video, '.video') === false) {
      (0, _lib.wrap)(video, 'video');
    }
  });
};

var _lib = __webpack_require__(2);

/***/ })
],[53]);


// WEBPACK FOOTER //
// designwise-0b30edc0185af5e9d401.js